import React from "react";

/** @typedef {import('../helpers/resolvePageHelp.js').PageHelpTopic} PageHelpTopic */

/**
 * @param {object} props
 * @param {string[]} [props.items]
 * @param {string} [props.testId]
 */
export function TrainingChecklist({ items = [], testId = "cq-training-checklist" }) {
  if (!items.length) return null;
  return (
    <ul className="cq-training-checklist" data-testid={testId}>
      {items.map((item) => (
        <li key={item} className="cq-training-checklist__item">
          <span className="cq-training-checklist__box" aria-hidden />
          {item.replace(/^□\s*/, "")}
        </li>
      ))}
    </ul>
  );
}

/**
 * @param {object} props
 * @param {string} props.title
 * @param {string[]} props.items
 * @param {string} [props.testId]
 */
export function TrainingChecklistSection({ title, items, testId }) {
  if (!items?.length) return null;
  return (
    <section className="cq-training-checklist-section" data-testid={testId}>
      <h3 className="cq-training-checklist-section__title">{title}</h3>
      <TrainingChecklist items={items} testId={testId ? `${testId}-list` : undefined} />
    </section>
  );
}
